import useUpdateDropTaskSubmissions from '../../../../../hooks/useUpdateDropTaskSubmissions'
import SharedTwitterTask, {
  Props,
} from '../../../../../shared_components/Missions/Types/Twitter'
import TaskAllocationAmount from '../../../../../shared_components/Missions/TaskAllocationAmount'

export default function TwitterTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdateDropTaskSubmissions()
  return (
    <SharedTwitterTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} rewardDisplay='XP' />}
    />
  )
}
